
import { css } from 'lit';
export default css`
.iframe-popup__iframe {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 3rem 5%;
  }

    @media (min-width: 1024px) {.iframe-popup__iframe {
      padding: 3rem 20%
  }
    }
  .iframe-popup__close {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  .iframe-popup__close {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .iframe-popup__close {
    display: none;
    position: fixed;
    width: 2rem;
    height: 2rem;
    top: .5rem;
    right: .5rem;
    z-index: 10000;
    border-radius: 50%;
    padding: 0.55rem;
    cursor: pointer;
  }
  @media (min-width: 1024px) {
  .iframe-popup__close {
      width: 3rem;
      height: 3rem;
      top: 2%;
      right: 15%;
      padding: 0.85rem
  }
    }
  .iframe-popup.open .iframe-popup__close {
      display: block;
    }
`;